<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
                <router-link to="/user/new" class="btn btn-info"><i class="fa fa-plus"></i> Adicionar
                    usuário</router-link>
            </div>
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-3 offset-md-3  mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-8 col-md-8 col-xs-12 col-sm-12">
                            <label for="">Nome</label>
                            <input type="text" id="name" class="form-control" placeholder="Ex: Usuário X"
                                v-model="advanced_search_input.name">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">CPF / CNPJ</label>
                            <input type="text" id="document" class="form-control" placeholder="Ex: xxx.xxx.xxx-xx"
                                v-model="advanced_search_input.document"
                                v-mask="['###.###.###-##', '##.###.###/####-##']">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-xl-8 col-md-8 col-xs-12 col-sm-12">
                            <label for="">E-mail</label>
                            <input type="text" id="name" class="form-control" placeholder="Ex: usuario@dominio.com"
                                v-model="advanced_search_input.email">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">Status</label>
                            <select class="form-control" v-model="advanced_search_input.status">
                                <option value="" disabled selected>Selecione uma opção</option>
                                <option value="all">Todos os status</option>
                                <option value="1">Apenas ativos</option>
                                <option value="0">Apenas inativos</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="alert alert-success" v-if="user.password != ''">A senha temporária de acesso de {{ user.name
                    }} é: <strong>{{ user.password }}</strong> <i class="fa fa-copy pointer"
                        @click="copyPassword()"></i>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Usuários
                            <br><small><span
                                    v-if="total_itens > 0">Total registros encontrados: {{ formatDecimal(total_itens) }}</span></small>
                        </h6> <button
                            class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i> Recarregar
                            dados</button>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nome</th>
                                        <th>Documento</th>
                                        <th>Tipo</th>
                                        <th>Perfil de acesso</th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center">Criado em</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(user, index) in users" :key="user.id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ capitalizeValue(user.name) }} </td>
                                        <td>{{ user.document_formatted }} </td>
                                        <td>{{ user.type == 'pf' ? 'Físico' : 'Jurídico' }} </td>
                                        <td>{{ user.role }} </td>
                                        <td class="text-center" v-if="user.status"><span
                                                class="badge badge-success">Ativo</span> </td>
                                        <td class="text-center" v-else><span class="badge badge-danger">Inativo</span>
                                        </td>
                                        <td class="text-center">{{ user.created_at }} </td>
                                        <td v-if="user.role != 'admin'">
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <router-link class="dropdown-item" :to="{
                                                        name: 'user_edit',
                                                        params: { id: user.id }
                                                    }">Detalhes</router-link>
                                                    <router-link class="dropdown-item" :to="{
                                                        name: 'user_activity',
                                                        params: { id: user.id }
                                                    }">Associação</router-link>
                                                    <button class="dropdown-item"
                                                        @click="resetPassword(user.id)">Resetar senha</button>
                                                    <button class="dropdown-item"
                                                        @click="deleteUser(user.id)">Excluir</button>
                                                </div>
                                            </div>
                                        </td>
                                        <td v-else> <button class="btn btn-primary dropdown-toggle" type="button"
                                                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false" disabled>
                                                Ações
                                            </button></td>
                                    </tr>
                                    <tr v-if="users.length > 0 && page > 1">
                                        <td colspan="8" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="users.length <= 0">
                                        <td colspan="8" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'

export default {
    directives: { mask },
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: { 'status': '' },
            users: [],
            page: 1,
            last_page: 1,
            total_itens: 0,
            user: {
                document: '',
                name: '',
                email: '',
                role_id: '',
                password: ''
            }
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        }
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.users = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.users = {}
            this.advanced_search_input = {}
            this.loadData();
        },

        capitalizeValue(value) {
            return capitalize(value);
        },

        formatDecimal(number) {
           return new Intl.NumberFormat().format(number)
        },

        loadData() {
            this.isLoading = true;

            api.get('/user', {
                params: {
                    'name': this.advanced_search_input.name,
                    'document': this.advanced_search_input.document,
                    'email': this.advanced_search_input.email,
                    'status': this.advanced_search_input.status,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.total_itens = response.data.total_itens;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.users = response.data.data;
                    } else {
                        this.users = this.users.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        deleteUser(id) {
            this.$confirm(
                {
                    message: 'Deseja apagar o usuário?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/user/' + id)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Usuário excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        resetPassword(id) {
            this.$confirm(
                {
                    message: 'Deseja resetar a senha usuário?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('/user/' + id + '/resetPassword')
                                .then((response) => {
                                    this.isLoading = false;
                                    this.user.name = response.data.user.name;
                                    this.user.password = response.data.password;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Senha resetada com sucesso!",
                                        type: 'success'
                                    });
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        copyPassword() {
            if (this.user.password != '') {
                navigator.clipboard.writeText(this.user.password);
                this.$notify({
                    title: "Informação",
                    text: "Senha copiada!",
                    type: 'success'
                });
            }
        }

    },
    mounted() {
        this.loadData();

    },
}
</script>

<style></style>